import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { grey5, grey7 } from 'approot/shared/styles/colours.style';
import {
  spacing16,
  spacing4,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { PStyled } from 'approot/shared/styles/typography.style';

export const AssignClassCodes = styled.div`
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  color: ${grey7};
  margin-bottom: ${rem(spacing16)};
  padding: ${rem(spacing8)} ${rem(spacing16)};
`;

export const AssignClassCodesLabel = styled(PStyled).attrs({
  marginBottom: spacing4,
  colour: grey7,
})``;

export const AssignQrContainer = styled.div`
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  display: inline-block;
  padding: ${rem(spacing4)};
`;
